import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { clearAllRequests } from 'store/ApiClient/actions';

const RouteMonitor: React.FC<RouteComponentProps> = ({ location }) => {
  const dispatch = useDispatch();
  const [, setCurrentPath] = useState(location.pathname);

  // Clear redux api requests on location change.
  useEffect(() => {
    dispatch(clearAllRequests());
    setCurrentPath(location.pathname);
  }, [location.pathname, dispatch]);

  return <></>;
};

export default withRouter(RouteMonitor);
